"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISO_CODES_TO_VAT_PREFIX_CODES_FOR_EU_COUNTRIES = void 0;
exports.startsWithCountryCode = startsWithCountryCode;
exports.getEuCountryCode = getEuCountryCode;
/**
 * Check if the VAT number starts with proper country code needed for VIES validation
 * For example: PL1234567890, where PL is the country code for Poland, DE1234567890, where DE is the country code for Germany
 *
 * @param vatNumber
 * @param countryIso country iso code (e.g. pl, de, gr, etc.)
 */
function startsWithCountryCode(vatNumber, countryIso) {
    const countryVatCode = getEuCountryCode(countryIso);
    return vatNumber.startsWith(countryVatCode);
}
exports.ISO_CODES_TO_VAT_PREFIX_CODES_FOR_EU_COUNTRIES = {
    GR: "EL",
};
/**
 * Each European Union country has its own country code, which translates to the VAT number prefix.
 * In most cases, the country code is the same as the ISO code, but there is an exception for Greece,
 * which has the country code "EL" and ISO code "GR".
 */
function getEuCountryCode(countryIso) {
    const upperCaseIso = countryIso.toUpperCase();
    return exports.ISO_CODES_TO_VAT_PREFIX_CODES_FOR_EU_COUNTRIES[upperCaseIso] ?? upperCaseIso;
}
//# sourceMappingURL=getEuCountryCode.js.map